import { render, staticRenderFns } from "./WelcomeScreen.vue?vue&type=template&id=474e5c20&"
import script from "./WelcomeScreen.vue?vue&type=script&lang=js&"
export * from "./WelcomeScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('474e5c20')) {
      api.createRecord('474e5c20', component.options)
    } else {
      api.reload('474e5c20', component.options)
    }
    module.hot.accept("./WelcomeScreen.vue?vue&type=template&id=474e5c20&", function () {
      api.rerender('474e5c20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/features/welcome/screens/WelcomeScreen.vue"
export default component.exports